import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { NavDropdown, ListGroup } from "react-bootstrap";
import NavbarLink from "../NavbarLink";
import Axios from "axios";

const Settings = ({ CanI }) => {
    const [state, setState] = useState({
        tasks_view_task_list: false,
        support_view_link: false,
        support_access_videos: false,
        has_accepted_tos: false
    });

    useEffect(() => {
        async function InitSettings() {
            const response = await Axios.get('/account/user');

            setState({
                ...state,
                tasks_view_task_list: await CanI("tasks_view_task_list"),
                support_view_link: await CanI("support_view_link"),
                support_access_videos: await CanI("support_access_videos"),
                has_accepted_tos: response.data.user.has_accepted_tos
            });
        }
        InitSettings();
    }, []);
    const {
        tasks_view_task_list,
        support_view_link,
        support_access_videos,
        has_accepted_tos
    } = state;

    return (
        <NavDropdown.ItemText>
            <ListGroup>
                {has_accepted_tos && (
                <ListGroup.Item>
                    <a href="/app/account" className="dropdown-item">
                        Account
                    </a>
                    {/*
                    <NavbarLink
                        to="/app/account"
                        className="dropdown-item"
                        label={`Account`}
                    />
                    */}
                </ListGroup.Item>
                )}
                <ListGroup.Item>
                    <NavbarLink
                        to="/app/trust_center"
                        className="dropdown-item"
                        label={`Trust Center`}
                    />
                </ListGroup.Item>
                {tasks_view_task_list && (
                    <ListGroup.Item>
                        <NavbarLink
                            to="/app/tasks"
                            className="dropdown-item"
                            label={`Tasks`}
                        />
                    </ListGroup.Item>
                )}
                {support_view_link && (
                    <ListGroup.Item>
                        <a
                            className="dropdown-item"
                            href="/zendesk/sso"
                            target="_blank"
                        >
                            Support
                        </a>
                    </ListGroup.Item>
                )}
                {support_access_videos && (
                    <ListGroup.Item>
                        <a className="dropdown-item" href="/app/videos">
                            Videos
                        </a>
                    </ListGroup.Item>
                )}
                <ListGroup.Item>
                    <a className="dropdown-item" href="/logout">
                        Logout
                    </a>
                </ListGroup.Item>
            </ListGroup>
        </NavDropdown.ItemText>
    );
};

Settings.propTypes = { CanI: PropTypes.func };

export default Settings;
